import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "spinner", "statusText", "errorText"]
  static values = { calculatorType: String }

  async generate(event) {
    event.preventDefault()
    this._showLoading()
    this._clearError()

    try {
      const params = this._readParams()
      const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

      const response = await fetch("/tools/generate-pdf", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          ...(csrfToken ? { "X-CSRF-Token": csrfToken } : {}),
        },
        body: JSON.stringify({
          calculator_type: this.calculatorTypeValue,
          params,
        }),
      })

      const data = await response.json()

      if (!response.ok) {
        if (response.status === 401 && data.sign_in_url) {
          window.location.href = data.sign_in_url
          return
        }
        this._showError(data.error || this._errorForStatus(response.status))
        return
      }

      if (data.status === "completed") {
        this._triggerDownload(data.download_url)
        this._hideLoading()
        return
      }

      this._showError("Unexpected response")
    } catch {
      this._showError("Network error. Please try again.")
    }
  }

  _triggerDownload(url) {
    window.location.href = url
  }

  _showLoading() {
    if (this.hasButtonTarget) this.buttonTarget.disabled = true
    if (this.hasSpinnerTarget) this.spinnerTarget.classList.remove("hidden")
    this._updateStatus("Preparing PDF...")
  }

  _hideLoading() {
    if (this.hasButtonTarget) this.buttonTarget.disabled = false
    if (this.hasSpinnerTarget) this.spinnerTarget.classList.add("hidden")
    this._updateStatus("")
  }

  _updateStatus(text) {
    if (this.hasStatusTextTarget) this.statusTextTarget.textContent = text
  }

  _showError(message) {
    this._hideLoading()
    if (this.hasErrorTextTarget) {
      this.errorTextTarget.textContent = message
      this.errorTextTarget.classList.remove("hidden")
    }
  }

  _clearError() {
    if (this.hasErrorTextTarget) {
      this.errorTextTarget.textContent = ""
      this.errorTextTarget.classList.add("hidden")
    }
  }

  _errorForStatus(status) {
    switch (status) {
      case 401:
        return "Please sign in to download PDF reports."
      case 403:
        return "PDF reports require a Pro subscription."
      default:
        return "Something went wrong. Please try again."
    }
  }

  _readParams() {
    const sp = new URLSearchParams(window.location.search)
    const params = {}
    for (const [key, value] of sp.entries()) {
      params[key] = value
    }
    return params
  }
}
